module.exports = ".mb-200 {\n  margin-bottom: 200px; }\n\n.panel-default > .panel-heading {\n  padding: 10px 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/generate-report/generate-report.component.scss
// module id = ./src/app/admin/generate-report/generate-report.component.scss
// module chunks = main